/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

/* COMPONENTS */
import ModalAddressBookV3 from '../../Modals/ModalAddressBookV3';
import ModalAddAddress from '../../Modals/ModalAddAddressV3';
// ========= action import section ========= //
import {
  getHistoryShipping,
  setDefaultAddress,
  deleteShippingAddress,
  doFetchCountries,
} from '../../../actions/postalCodeAction';
// ====== end of action import section ====== //

// ========= interface import section ========= //
import DataPostalCodeInterface, {
  CountriesInterface,
  ShippingHistoryInterface,
} from '../../../interface/reducers/postalCode';
// ====== end of interface import section ====== //

/* ASSETS */
import address from '../../../images/address.png';

const addressIcon: any = address;

type stateToProps = {
  dataPostalCode: DataPostalCodeInterface;
};

interface AddressBookInterface extends stateToProps {
  dataAddress: ShippingHistoryInterface[];
  countries: CountriesInterface[];
  doFetchHistoryShipping: () => Promise<any>;
  changeAddressDefault: (payload: any) => Promise<any>;
  deleteShippingAddress: (payload: any) => Promise<any>;
  getCountries: (payload?: any) => Promise<any>;
}

/**
 * Address Book Tab on Setting User Dashboard section for Kick Avenue 3.0 Website.
 * ===============================================
 * @param {AddressBookInterface} props for this component.
 * @return {JSX.Element}
 */
function AddressBookTab({
  dataAddress,
  countries,
  dataPostalCode,
  changeAddressDefault,
  doFetchHistoryShipping,
  deleteShippingAddress,
  getCountries,
}: AddressBookInterface): JSX.Element {
  const [isOpenedAddressBookModal, setOpenedAddressBookModal] = useState(false);
  const [shippingId, setShippingId] = useState<number | null>(null);
  const [isAddressButtonDisable, setIsAddressButtonDisable] = useState(false);
  const [defaultId, setDefaultId] = useState<number | null>(0);
  const [addressList, setAddressList] = useState<ShippingHistoryInterface>([]);
  const [modalForm, setModalForm] = useState<boolean>(false);
  const [titleHeader, setTitleHeader] = useState<string>('');
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [editId, setEditId] = useState<number | undefined | null>(0);
  const [isSetDefaultProcess, setSetDefaultProcess] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [confirmationText, setConfirmationText] = useState<{
    text: string;
    title: string;
    status: string;
    id: null | number;
  }>({
    text: '',
    status: '',
    id: null,
  });

  /* METHODS | FUNCTIONS |HANDLERS */
  const toggleAddressBookModal = () => {
    setOpenedAddressBookModal(!isOpenedAddressBookModal);
  };

  const changeId = (id: number) => {
    setIsAddressButtonDisable(true);
    setShippingId(id);
  };

  const submitShipping = async () => {
    setIsAddressButtonDisable(false);
    setDefaultId(shippingId);
    changeAddressDefault(shippingId).then(() => {
      setShippingId(0);
      setDefaultId(0);
      doFetchHistoryShipping().then(() => {
        toggleAddressBookModal();
      });
    });
  };

  const toggleModalForm = (title: string, id: number | null) => {
    if (title === 'Edit Address') {
      setIsEdit(true);
      setTitleHeader(title);
      setModalForm(!modalForm);
      setEditId(id);
    } else {
      setIsEdit(false);
      setTitleHeader(title);
      setModalForm(!modalForm);
    }
  };

  const changeDefaultAddress = (id: number | null) => {
    setSetDefaultProcess(true);
    changeAddressDefault(id).then(() => doFetchHistoryShipping()).catch(() => doFetchHistoryShipping());
  };

  const deleteAddress = (id: number | null) => {
    if (!id) return;
    deleteShippingAddress(id)
      .then(() => doFetchHistoryShipping())
      .catch(() => null);
  };

  /* COMPONENT DID MOUNT */
  useEffect(() => {
    if (isSetDefaultProcess) {
      doFetchHistoryShipping();
      setSetDefaultProcess(false);
    }
  }, [isSetDefaultProcess]);

  useEffect(() => {
    setAddressList(dataAddress);
  }, [dataAddress]);

  useEffect(() => {
    setAddressList([]);
    doFetchHistoryShipping();
    getCountries();
  }, []);

  /* COMPONENTS */
  const renderConfirmationModal = () => {
    const { text, id, status, title } = confirmationText;
    return openConfirmationModal ? (
      <Modal show={openConfirmationModal} id="confirmation-wrapper">
        <div className="confirmation-content-wrapper">
          <p className={'title'}>{title}</p>
          <p className={'description'}>{text}</p>
          <div className="button-wrapper">
            <button onClick={() => setOpenConfirmationModal(false)}>
              <p>No</p>
            </button>
            <button
              onClick={() => {
                setOpenConfirmationModal(false);
                switch (status) {
                  case 'delete':
                    deleteAddress(id);
                    break;
                  case 'default':
                    changeDefaultAddress(id);
                    break;
                  default:
                    break;
                }
              }}
            >
              <p>Yes</p>
            </button>
          </div>
        </div>
      </Modal>
    ) : null;
  };

  return (
    <div
      id="settings-address-book"
      className={`${addressList.length === 0 ? 'empty' : ''} `}
    >
      {addressList.length > 0 ? (
        <div className="address-book-container">
          <div className="address-book-header">
            <p>Address List</p>
            <button
              onClick={() => toggleModalForm('Add New Address', null)}
              className="add-new-address"
            >
              +
            </button>
          </div>
          <div className="address-cards-container">
            {addressList.map((address) => {
              const {
                is_default,
                phone_number,
                street_address,
                alias,
                full_name,
                city,
                province,
                postal_code,
                country,
                id,
              } = address;
              return (
                <div key={id} className="address-card">
                  <div className="address-info-wrapper">
                    <p>
                      {alias} - {full_name}
                    </p>
                    <p>{phone_number}</p>
                    <p>{street_address},</p>
                    <p>
                      {city}, {province} {postal_code}
                    </p>
                    <p>{country}</p>
                  </div>
                  <div className="address-action-container">
                    {is_default ? (
                      <div className="default-address">
                        <p>Default Address</p>
                      </div>
                    ) : (
                      <a
                        onClick={() => {
                          setConfirmationText({
                            text: 'Set this address as default address ?',
                            title: '',
                            status: 'default',
                            id: id,
                          });
                          setOpenConfirmationModal(true);
                        }}
                      >
                        Set as default address
                      </a>
                    )}
                    <a onClick={() => toggleModalForm('Edit Address', id)}>
                      Edit
                    </a>
                    {!is_default && (
                      <a
                        onClick={() => {
                          setConfirmationText({
                            title: 'Delete address',
                            text: 'Are you sure want to delete this address?',
                            status: 'delete',
                            id: id,
                          });
                          setOpenConfirmationModal(true);
                        }}
                      >
                        Delete
                      </a>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="empty-address-container">
          <div className="icon-wrapper">
            <KickImage src={addressIcon} alt="..." />
          </div>
          <div className="text-wrapper">
            <p>You haven’t add any address yet.</p>
            <p>Add your first shipping address by click the button below.</p>
          </div>
          <div className="add-new-address">
            <button onClick={() => toggleModalForm('Add New Address', null)}>
              <p>Add New Address</p>
            </button>
          </div>
        </div>
      )}
      {modalForm && (
        <ModalAddAddress
          dataAddress={dataAddress}
          isOpen={modalForm}
          onToggle={toggleModalForm}
          title={titleHeader}
          countries={countries}
          isEdit={isEdit}
          editId={editId}
          toggleAdd={toggleAddressBookModal}
        />
      )}
      <ModalAddressBookV3
        isOpen={isOpenedAddressBookModal}
        onToggle={toggleAddressBookModal}
        dataAddress={dataPostalCode.shippingHistory.data}
        countries={dataPostalCode.countries.data}
        provinces={dataPostalCode.provinces.data}
        cities={dataPostalCode.cities.data}
        id={shippingId}
        changeId={changeId}
        defaultId={defaultId}
        submitShipping={submitShipping}
        getHistoryShipping={doFetchHistoryShipping}
        isModalOffer={true}
        isAddressButtonDisable={isAddressButtonDisable}
        modalTitle={'Change Default Address'}
        type={'set-default'}
      />
      {renderConfirmationModal()}
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataAddress: state.dataPostalCode.shippingHistory.data,
    countries: state.dataPostalCode.countries.data,
    dataPostalCode: state.dataPostalCode,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doFetchHistoryShipping: () => dispatch(getHistoryShipping()),
    changeAddressDefault: (payload: any) =>
      dispatch(setDefaultAddress(payload)),
    deleteShippingAddress: (payload: any) =>
      dispatch(deleteShippingAddress(payload)),
    getCountries: () => dispatch(doFetchCountries()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressBookTab);
